<div class="close">
  <button mat-dialog-close>
    <img
      alt="close"
      width="24"
      height="24"
      src="../../../assets/images/close.svg"
    />
  </button>
</div>
<div class="title">{{ data.platform_name }} 售后服务</div>
<div class="content">
  <div class="part">
    <div class="part-title">{{ data?.problem }}</div>
    <div class="detail">
      <ng-container *ngFor="let item of data?.problems">
        <div
          class="item"
          *ngIf="item.status === 'InUse'"
          (click)="solveProblem(item)"
        >
          <span class="plot orange"></span>
          <span>{{ item?.problem }}</span>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="button">
    <button (click)="close()">确定</button>
  </div>
</div>
